import * as Updates from 'expo-updates';

import {Image, Text, TouchableOpacity, View} from 'react-native';

import React from 'react';
import {setExpoUpdateAvailable} from './Redux/reducers/app_info.reducer';

import AppLink from 'react-native-app-link';
import {dispatchAction} from 'src/Utils/helpers';
import {useSelector} from 'react-redux';

const upgradeImage = {
  uri: 'https://photos.letsroam.com/photos_other/scavenger-hunt-location-1648577952_medium.png',
};

// Props passed in from use copilot
const UpgradeView = () => {
  const expoUpdateAvailable = useSelector((state) => {
    if (window) {
      window.state = state;
    }
    return state.app_info?.expoUpdateAvailable;
  });
  return (
    <View
      style={{
        flex: 1,
        backgroundColor: 'rgba(80, 87, 89, 1)',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <View style={{height: 360, width: 300, backgroundColor: 'white'}}>
        <Image
          style={{
            height: 300,
            width: 300,
            backgroundColor: 'white',
            resizeMode: 'contain',
          }}
          source={upgradeImage}
        />
        <View
          style={{
            height: 10,
            width: 300,
            backgroundColor: 'rgba(80, 87, 89, 1)',
          }}
        />
        <TouchableOpacity
          style={{
            height: 50,
            width: 300,
            backgroundColor: 'rgba(232, 119, 34, 1)',
            justifyContent: 'center',
            alignItems: 'center',
            alignContent: 'center',
          }}
          onPress={() => {
            expoUpdateAvailable
              ? Updates.reloadAsync()
                  .then(() => {})
                  .catch(() => {
                    // global.devAlert(error);
                    dispatchAction(setExpoUpdateAvailable(0));
                  })
              : AppLink?.openInStore({
                  appStoreId: '1338916789',
                  playStoreId: 'com.barhuntv2',
                });
          }}>
          <Text
            style={{
              fontFamily: 'Alternate Gothic No3 D',
              fontSize: 30,
              color: 'white',
              textAlign: 'center',
            }}>
            {'UPGRADE YOUR APP'}
          </Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default UpgradeView;
